// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (width <= 767px) {
    h1{
        font-size:25px;
    }   

    h2{
        font-family: sans-serif;
        font-weight: 600;
        font-size: 18px!important;
        text-align: left;
        margin-top: 20px;
        }
    }

    h2{
    font-family: sans-serif;
    font-weight: 600;
    font-size: 30px;
    text-align: left;
    margin-top: 20px;
    }

.youtube {
    background-color: #000;
    margin-bottom: 10px;
    margin-top: 30px;
    position: relative;
    padding-top: 56.25%;
    overflow: hidden;
    cursor: pointer;
}

.main_h4 {
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
}

.youtube img {
    width: 100%;
    top: -16.82%;
    left: 0;
    opacity: 0.95;
     transition: 1s;
}

.youtube .play-button {
    width: 90px;
    height: 60px;
    background-color: #333;
    box-shadow: 0 0 30px rgb(0 0 0 / 60%);
    z-index: 1;
    opacity: 0.8;
    border-radius: 16px;
}

.youtube:hover .play-button {
    background-color: #f00;
}

.youtube:hover img {
    transition: 1s;
    transform: scale(1.1);
}

.youtube .play-button::before {
    content: "";
    border-style: solid;
    border-width: 15px 0 15px 26.0px;
    border-color: transparent transparent transparent #fff;
}

.youtube img,
.youtube .play-button {
    cursor: pointer;
}

.youtube img,
.youtube iframe,
.youtube .play-button,
.youtube .play-button::before {
    position: absolute;
}

.youtube .play-button,
.youtube .play-button::before {
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
}

.youtube iframe {
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
}

/* .listing-page .listing-slide .card-im{
    padding: 1px 16px;
box-shadow: 2px 2px 5px 0 #00000057;
width: 100%;
background-color: #f7f7f7 !important;
} */

/* .listing-page .listing-slide .card-im img{
    height: auto;
} */
.list_headline_two{
    min-height:80px;
}

/* =============Search====== */
.searchbar {
     position: relative;
     min-width: 50px;
     width: 0%;
     height: 50px;
     float: right;
     overflow: hidden;
     transition: width 0.3s
 }

 .searchbar-input {
     top: 0;
     right: 0;
     border: 0;
     outline: 0;
     background: #ebebeb;
     width: 100%;
     height: 50px;
     margin: 0;
     padding: 0 55px 0 20px;
     font-size: 17px;
     color: #000
 }

 .searchbar-input::input-placeholder {
     color: #000
 }

 .searchbar-input:placeholder {
     color: #000
 }

 .searchbar-input::placeholder {
     color: #000
 }

 .searchbar-input:input-placeholder {
     color: #000
 }

 .searchbar-icon,
 .searchbar-submit {
     width: 50px;
     height: 50px;
     display: block;
     position: absolute;
     top: 0;
     font-family: verdana;
     font-size: 22px;
     right: 0;
     padding: 0;
     margin: 0;
     border: 0;
     outline: 0;
     line-height: 50px;
     text-align: center;
     cursor: pointer;
     color: #fff;
     background: #2067d1;
     border-left: 1px solid white
 }

 .searchbar-open {
     width: 100%
 }

 .styled-link {
    color: black;
    text-decoration: none;
    font-weight: normal; /* Adjust as needed */
}

  .styled-link:hover {
    color: black; /* Keep the color black on hover */
    text-decoration: none; /* Keep the underline removed on hover */
    cursor: default; /* Change the cursor to default on hover */
}


 .styled-link {
    text-decoration: none; /* Remove underline */
    color: black; /* Default color */
}

.styled-link:hover {
    font-weight: bold; /* Make text bold on hover */
    color: blue; /* Change text color to blue on hover */
}

/* .listing-page .listing-slide .card-im {
    padding: 1px 16px;
    box-shadow: 2px 2px 5px 0 #00000057;
    width: 100%;
    background-color: #ffffff00 !important;
} */`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/video.css"],"names":[],"mappings":"AAAA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;QAChB,yBAAyB;QACzB,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;;IAEA;IACA,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB;;AAEJ;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,OAAO;IACP,aAAa;KACZ,cAAc;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,qCAAqC;IACrC,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gCAAgC;IAChC,sDAAsD;AAC1D;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;;IAEI,QAAQ;IACR,SAAS;IACT,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,MAAM;IACN,OAAO;AACX;;AAEA;;;;;GAKG;;AAEH;;GAEG;AACH;IACI,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;KACK,kBAAkB;KAClB,eAAe;KACf,SAAS;KACT,YAAY;KACZ,YAAY;KACZ,gBAAgB;KAChB;CACJ;;CAEA;KACI,MAAM;KACN,QAAQ;KACR,SAAS;KACT,UAAU;KACV,mBAAmB;KACnB,WAAW;KACX,YAAY;KACZ,SAAS;KACT,sBAAsB;KACtB,eAAe;KACf;CACJ;;CAEA;KACI;CACJ;;CAEA;KACI;CACJ;;CAEA;KACI;CACJ;;CAEA;KACI;CACJ;;CAEA;;KAEI,WAAW;KACX,YAAY;KACZ,cAAc;KACd,kBAAkB;KAClB,MAAM;KACN,oBAAoB;KACpB,eAAe;KACf,QAAQ;KACR,UAAU;KACV,SAAS;KACT,SAAS;KACT,UAAU;KACV,iBAAiB;KACjB,kBAAkB;KAClB,eAAe;KACf,WAAW;KACX,mBAAmB;KACnB;CACJ;;CAEA;KACI;CACJ;;CAEA;IACG,YAAY;IACZ,qBAAqB;IACrB,mBAAmB,EAAE,qBAAqB;AAC9C;;EAEE;IACE,YAAY,EAAE,kCAAkC;IAChD,qBAAqB,EAAE,wCAAwC;IAC/D,eAAe,EAAE,0CAA0C;AAC/D;;;CAGC;IACG,qBAAqB,EAAE,qBAAqB;IAC5C,YAAY,EAAE,kBAAkB;AACpC;;AAEA;IACI,iBAAiB,EAAE,4BAA4B;IAC/C,WAAW,EAAE,uCAAuC;AACxD;;AAEA;;;;;GAKG","sourcesContent":["@media (width <= 767px) {\n    h1{\n        font-size:25px;\n    }   \n\n    h2{\n        font-family: sans-serif;\n        font-weight: 600;\n        font-size: 18px!important;\n        text-align: left;\n        margin-top: 20px;\n        }\n    }\n\n    h2{\n    font-family: sans-serif;\n    font-weight: 600;\n    font-size: 30px;\n    text-align: left;\n    margin-top: 20px;\n    }\n\n.youtube {\n    background-color: #000;\n    margin-bottom: 10px;\n    margin-top: 30px;\n    position: relative;\n    padding-top: 56.25%;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n.main_h4 {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 28px;\n}\n\n.youtube img {\n    width: 100%;\n    top: -16.82%;\n    left: 0;\n    opacity: 0.95;\n     transition: 1s;\n}\n\n.youtube .play-button {\n    width: 90px;\n    height: 60px;\n    background-color: #333;\n    box-shadow: 0 0 30px rgb(0 0 0 / 60%);\n    z-index: 1;\n    opacity: 0.8;\n    border-radius: 16px;\n}\n\n.youtube:hover .play-button {\n    background-color: #f00;\n}\n\n.youtube:hover img {\n    transition: 1s;\n    transform: scale(1.1);\n}\n\n.youtube .play-button::before {\n    content: \"\";\n    border-style: solid;\n    border-width: 15px 0 15px 26.0px;\n    border-color: transparent transparent transparent #fff;\n}\n\n.youtube img,\n.youtube .play-button {\n    cursor: pointer;\n}\n\n.youtube img,\n.youtube iframe,\n.youtube .play-button,\n.youtube .play-button::before {\n    position: absolute;\n}\n\n.youtube .play-button,\n.youtube .play-button::before {\n    top: 50%;\n    left: 50%;\n    transform: translate3d(-50%, -50%, 0);\n}\n\n.youtube iframe {\n    height: 100%;\n    width: 100%;\n    top: 0;\n    left: 0;\n}\n\n/* .listing-page .listing-slide .card-im{\n    padding: 1px 16px;\nbox-shadow: 2px 2px 5px 0 #00000057;\nwidth: 100%;\nbackground-color: #f7f7f7 !important;\n} */\n\n/* .listing-page .listing-slide .card-im img{\n    height: auto;\n} */\n.list_headline_two{\n    min-height:80px;\n}\n\n/* =============Search====== */\n.searchbar {\n     position: relative;\n     min-width: 50px;\n     width: 0%;\n     height: 50px;\n     float: right;\n     overflow: hidden;\n     transition: width 0.3s\n }\n\n .searchbar-input {\n     top: 0;\n     right: 0;\n     border: 0;\n     outline: 0;\n     background: #ebebeb;\n     width: 100%;\n     height: 50px;\n     margin: 0;\n     padding: 0 55px 0 20px;\n     font-size: 17px;\n     color: #000\n }\n\n .searchbar-input::input-placeholder {\n     color: #000\n }\n\n .searchbar-input:placeholder {\n     color: #000\n }\n\n .searchbar-input::placeholder {\n     color: #000\n }\n\n .searchbar-input:input-placeholder {\n     color: #000\n }\n\n .searchbar-icon,\n .searchbar-submit {\n     width: 50px;\n     height: 50px;\n     display: block;\n     position: absolute;\n     top: 0;\n     font-family: verdana;\n     font-size: 22px;\n     right: 0;\n     padding: 0;\n     margin: 0;\n     border: 0;\n     outline: 0;\n     line-height: 50px;\n     text-align: center;\n     cursor: pointer;\n     color: #fff;\n     background: #2067d1;\n     border-left: 1px solid white\n }\n\n .searchbar-open {\n     width: 100%\n }\n\n .styled-link {\n    color: black;\n    text-decoration: none;\n    font-weight: normal; /* Adjust as needed */\n}\n\n  .styled-link:hover {\n    color: black; /* Keep the color black on hover */\n    text-decoration: none; /* Keep the underline removed on hover */\n    cursor: default; /* Change the cursor to default on hover */\n}\n\n\n .styled-link {\n    text-decoration: none; /* Remove underline */\n    color: black; /* Default color */\n}\n\n.styled-link:hover {\n    font-weight: bold; /* Make text bold on hover */\n    color: blue; /* Change text color to blue on hover */\n}\n\n/* .listing-page .listing-slide .card-im {\n    padding: 1px 16px;\n    box-shadow: 2px 2px 5px 0 #00000057;\n    width: 100%;\n    background-color: #ffffff00 !important;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
